import { CustomerBusinessStatus } from '@plato/data/starrocks/types';
import {
    Card,
    CardContent,
    CardFront,
    CardHeader,
    CardStart,
    CardSubtitle,
    CardTitle,
} from '@plato/ui/containers/card';
import type { TFunction } from 'i18next';
import { ArrowRightIcon } from 'lucide-react';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import type { CrmCustomerStatusChangeDTO } from '../../../server/dto/crm-customer-status-change-dto.ts';

function getStatusChangeLabel(t: TFunction<'activity-feed'>, toStatus: CustomerBusinessStatus): string {
    switch (toStatus) {
        case CustomerBusinessStatus.INACTIVE:
            return t('log__status_inactive');
        case CustomerBusinessStatus.ACTIVE:
            return t('log__status_active');
    }
}

export type ActivityFeedCustomerStatusChangeItemProps = {
    payload: CrmCustomerStatusChangeDTO;
};

/**
 * A customer marked inactive or active again, as a bare, inert log line:
 * the change in grey, who made it on the right — above the text once the row is narrow.
 */
export function ActivityFeedCustomerStatusChangeItem({
    payload,
}: ActivityFeedCustomerStatusChangeItemProps): ReactElement {
    const { t } = useTranslation('activity-feed');

    return (
        <Card>
            <CardFront>
                <CardStart render={<ArrowRightIcon />} />
                {/* min-w-0 lets the row shrink, so the text wraps instead of overflowing */}
                <CardContent className="min-w-0">
                    <CardHeader>
                        <CardTitle className="line-clamp-2 text-content-weaker">
                            {getStatusChangeLabel(t, payload.toStatus)}
                        </CardTitle>
                        <CardSubtitle>
                            <span className="truncate">{payload.createdBy.fullName}</span>
                        </CardSubtitle>
                    </CardHeader>
                </CardContent>
            </CardFront>
        </Card>
    );
}
